module.exports = __webpack_public_path__ + "static/media/biabo-inicio.4102c49e.png";